import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getMqttUsedKeys } from "../../../action/metrics";
import { series_x_data, seriesXaxisData, mqttKeysSeriesData } from "./GraphParameter";
import Graph from "./Graph";
import FormInput from "../FormInputs/MuiTextField";
import MuiDatePicker from "../FormInputs/MuiDatePicker";
import AppButton from "../Button/Button";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

function MqttUsedKeysChart({ getMqttUsedKeys, mqttKeysUsed, formateDate, selectedGraph, allowedDeviceCategories }) {
  const [devicesCatogary, setDevicesCatogary] = useState("AC");
  const [startDate, setStartDate] = useState();
  const [disableDaily, setDisableDaily] = useState(true);

  useEffect(() => {
    const que = {
      "category":devicesCatogary
    }
    getMqttUsedKeys(que);
  }, [getMqttUsedKeys,devicesCatogary]);
  const handleDeviceCategory = (event) => {
    setDevicesCatogary(event.target.value);
  };
  const handleStartDateChange = (date) => {
    setStartDate(date);
  };
  const HandleDeviceControlFilter = (date) => {
    if (date) {
      const que = {
        "onDate": formateDate(date),
        "category":devicesCatogary
      };
      getMqttUsedKeys(que);
      setDisableDaily(false)
    }
  };
  let key_data = [];
  let y_data = [];
  let x_data = [];
  if(mqttKeysUsed.length) {
    key_data = series_x_data(mqttKeysUsed);
    x_data = seriesXaxisData(mqttKeysUsed,selectedGraph)
    y_data = mqttKeysSeriesData(mqttKeysUsed,key_data)
  }
  const handleDeviceControl = () => {
    setDisableDaily(true);
    const que = {
      "category":devicesCatogary
    }
    getMqttUsedKeys(que);
    setStartDate("");
  };
  return (
    <Box>
      <Grid2 container spacing={2} sx={{ mb: 2 }}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "nowrap" }}>
            <MuiDatePicker
              label="Select Date"
              value={startDate || null}
              maxDate={new Date()}
              onChange={handleStartDateChange}
            />
            <AppButton
              variant="primary"
              size="medium"
              sx={{ flexShrink: 0 }}
              onClick={() => HandleDeviceControlFilter(startDate)}
            >
              Search
            </AppButton>
            {!disableDaily && (
              <AppButton
                variant="ghost"
                size="medium"
                sx={{ flexShrink: 0 }}
                onClick={handleDeviceControl}
              >
                Daily
              </AppButton>
            )}
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <FormInput
            type="select"
            size="small"
            fullWidth
            label="Device Category"
            value={devicesCatogary}
            onChange={handleDeviceCategory}
            options={(allowedDeviceCategories ?? []).map((category) => ({ value: category, label: category }))}
            displayEmpty
          />
        </Grid2>
      </Grid2>
      <Box>
        <Graph
          text={" mqtt key "}
          x_data={x_data}
          title={"Number Of mqtt Keys "}
          y_data={y_data}
          stacked={true}
        />
      </Box>
    </Box>
  );
}
const mapStateToProps = (state) => {
  return {
    mqttKeysUsed: state.metrics.mqttKeysUsed,
  allowedDeviceCategories:state.auth.allowedDeviceCategories,

  };
};

export default connect(mapStateToProps, { getMqttUsedKeys })(MqttUsedKeysChart);
